define("shared/components/shared/post/secondary/caption-writer/footer", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--modalFooter tCW--modalFooter qa--aiCreditsLeft_footer" data-test-id="footer-root">
    {{#if @shouldDisplayCreditPurchase}}
      <Shared::Ui::Button
        @class="o--btn--block u--m__tb__xs"
        @onClick={{@hideCreditPurchase}}
        @text={{t "shared_words.cancel"}}
        @variant="outline"
        data-test-id="footer-credit-purchase-cancel-button"
      />
    {{else}}
      {{svg-jar "credit" class="o--icon u--m__r__xs"}}
      <span>
        {{t
          "caption_writer.usage_warning.counter"
          creditsForPlan=@creditCountForPlan
          remainingCredits=@remainingCaptionGenerationUsages
        }}
      </span>
      {{#unless @isEnterpriseSubscription}}
        <Shared::Ui::Button
          @class="u--text--success u--m__l__xs qa--credit-counter_upgrade_plan_link"
          @onClick={{@showCreditPurchase}}
          @text={{t "caption_writer.usage_warning.need_more_credits"}}
          @variant="actionLink"
          data-test-id="footer-show-credit-purchase-button"
        />
      {{/unless}}
    {{/if}}
  </div>
  */
  {
    "id": "9Q6dQPJC",
    "block": "[[[10,0],[14,0,\"o--modalFooter tCW--modalFooter qa--aiCreditsLeft_footer\"],[14,\"data-test-id\",\"footer-root\"],[12],[1,\"\\n\"],[41,[30,1],[[[1,\"    \"],[8,[39,1],[[24,\"data-test-id\",\"footer-credit-purchase-cancel-button\"]],[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[\"o--btn--block u--m__tb__xs\",[30,2],[28,[37,2],[\"shared_words.cancel\"],null],\"outline\"]],null],[1,\"\\n\"]],[]],[[[1,\"    \"],[1,[28,[35,3],[\"credit\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,\"\\n    \"],[10,1],[12],[1,\"\\n      \"],[1,[28,[35,2],[\"caption_writer.usage_warning.counter\"],[[\"creditsForPlan\",\"remainingCredits\"],[[30,3],[30,4]]]]],[1,\"\\n    \"],[13],[1,\"\\n\"],[41,[51,[30,5]],[[[1,\"      \"],[8,[39,1],[[24,\"data-test-id\",\"footer-show-credit-purchase-button\"]],[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[\"u--text--success u--m__l__xs qa--credit-counter_upgrade_plan_link\",[30,6],[28,[37,2],[\"caption_writer.usage_warning.need_more_credits\"],null],\"actionLink\"]],null],[1,\"\\n\"]],[]],null]],[]]],[13]],[\"@shouldDisplayCreditPurchase\",\"@hideCreditPurchase\",\"@creditCountForPlan\",\"@remainingCaptionGenerationUsages\",\"@isEnterpriseSubscription\",\"@showCreditPurchase\"],false,[\"if\",\"shared/ui/button\",\"t\",\"svg-jar\",\"unless\"]]",
    "moduleName": "shared/components/shared/post/secondary/caption-writer/footer.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});